import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import { getEventList } from '../../state/reducers';
import schemaResolver from '../../state/resolvers/schema/event';
import { eventAbridgedPropType as eventPropTypeShape } from '../../proptypes';

import Meta from '../../components/Meta';

/**
 * Meta container.
 * Wraps the meta presentational component with schemata data
 */
const MetaContainer = ({ eventLists, queries, schemata, ...props }) => {
  const eventListsSchemata = eventLists && eventLists.length &&
    eventLists[0].map(event => schemaResolver(event));
  return (
    <Meta
      schemata={(schemata || []).concat(eventListsSchemata || [])}
      {...props}
    />
  );
};

MetaContainer.propTypes = {
  eventLists: PropTypes.arrayOf(eventPropTypeShape).isRequired,
  queries: PropTypes.arrayOf(PropTypes.shape().isRequired).isRequired,
  schemata: PropTypes.arrayOf(
    PropTypes.shape({
      innerHTML: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
};

MetaContainer.defaultProps = {
  eventLists: [],
  queries: [],
  schemata: [],
};

// Selectors are used so state shape is encapsulated within reducers
const mapStateToProps = (state, { queries }) => ({
  eventLists: queries.map(query => getEventList(state, query)),
});

// Wrap in [react-redux connect](https://github.com/reactjs/react-redux/blob/master/docs/api.md#connect)
const MetaContainerWithRedux = connect(mapStateToProps)(MetaContainer);

export default MetaContainerWithRedux;



// WEBPACK FOOTER //
// ./app/src/containers/Meta/index.jsx